module.exports = __webpack_public_path__ + "static/media/defaultFont.1cc5d205.webp";